<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>提供設定（一括）</v-toolbar>      
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="5" md="5" lg="5">
                <RyouDateFormat v-model="collectiveStartDate" :value="collectiveStartDate" :type="'date'"
                                :format="'$1/$2/$3'" :label="'一括登録開始日'" :min="deadLineDay" :max="getFutureDay()"
                                :rules="dateRules" style="width: 40%;"></RyouDateFormat>
              </v-col>
              <v-col class="text-center" cols="12" sm="2" md="2" lg="2">
                <h2>{{this.wavyLineMark}}</h2>
              </v-col>
              <v-col cols="12" sm="5" md="5" lg="5">
                <RyouDateFormat v-model="collectiveEndDate" :value="collectiveEndDate" :type="'date'"
                                :format="'$1/$2/$3'" :label="'一括登録終了日'" :rules="dateRules" :min="selectMin" :max="getFutureDay()"
                                style="width: 40%;"></RyouDateFormat>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="1" v-for="(item,index) in dateItems" :key="index">
                <v-checkbox v-model="selectedDates" :value="item.day" :label="item.day_name"></v-checkbox>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="2" v-for="(item,index) in mealNames" :key="index">
                <v-checkbox v-model="selectedMeals" :value="item.meal_class" :label="item.meal_name" :rules="checkBoxRules"></v-checkbox>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-form>            
        </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel"
                              :iconCls="'mdi-close'"></ryou-black-btn>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'一括給食'" :handlerClick="collectiveOn">
              </ryou-black-btn>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'一括休食'" :handlerClick="collectiveOff">
              </ryou-black-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
      </v-card>
    </v-container>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-dialog>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
  import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";

  export default {
    name: "MealLunchDialog",
    components: {
      RyouBlackBtn,
      RyouConfirm,
      RyouDateFormat,
    },
    props: {
      mealNames: {
        type: Array,
        required: true
      },
      mealDeadLineDay: {
        type: String,
        required: true
      },
      buildGroupId: {
        type: String,
        required:true
      }
    },
    data() {
      return {
        valid: true,
        wavyLineMark: "　～　",
        dialog: false,
        deadLineDay:"",
        collectiveStartDate: "",  //一括登録開始日
        collectiveEndDate: "",    //一括登録終了日
        dateRules: [],            //日付ルール
        checkBoxRules:[],        //曜日選択ルール
        selectMin: "",            //終了日選択の最小日付
        dateItems: [
          { day: "0", day_name: "日" },
          { day: "1", day_name: "月" },
          { day: "2", day_name: "火" },
          { day: "3", day_name: "水" },
          { day: "4", day_name: "木" },
          { day: "5", day_name: "金" },
          { day: "6", day_name: "土" }],
        selectedDates: [],
        selectedMeals: [],
        confirmMessage: "更新します。宜しいですか？",
        confirmColor: "info",
        warningMessage: "提供なしに設定した場合、その食事予約がキャンセルされ、メニューが削除されます。宜しいですか？",
        warningColor: "warning",
      };
    },
    mounted() {
      this.dateRules.push(this.GlobalRules.required)
      this.checkBoxRules.push( value => value.length > 0)
    },
    watch: {
      collectiveStartDate(value) {

        //開始日選択済み => 選択開始日 , 開始日未選択 => デッドライン
        if (value != null && value != "") {
          this.selectMin = value;
        } else {
          this.selectMin = this.deadLineDay;
        }

        //開始日 > 終了日 => 終了日をクリア
        let fromDate = new Date(
          Date.parse(this.collectiveStartDate)
        );
        let toDate = new Date(
          Date.parse(this.collectiveEndDate)
        );
        if (fromDate.getTime() > toDate.getTime()) {
          this.collectiveEndDate = "";
        }
      },
    },
    methods: {
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      collectiveOn() {
        var valid = this.$refs.p1DialogForm.validate();
        if (valid) {
          this.confirn(this.confirmMessage, this.confirmColor, "1")
        }       
      },
      collectiveOff() {
        var valid = this.$refs.p1DialogForm.validate();
        if (valid) {
          this.confirn(this.warningMessage, this.warningColor, "0")
        }      
      },
      //確認ダイアログを表示
      confirn(message, pColor, offerFlg) {
        this.$refs.confirm.open("更新", message, { color: pColor })
          .then((confirm) => {
            if (confirm) {
             // this.submit();
              this.collectiveUpdate(offerFlg)
            }
          });
      }
      ,
      close() {
        //this.$refs.p1DialogForm.resetValidation(); //検証リセット
        this.$refs.p1DialogForm.reset(); //検証と入力内容をリセット
        this.dialog = false;
        this.$emit("reCalendar");
      },
      open() {
        //締切日＋１にする
        var date = new Date(this.mealDeadLineDay)
        date.setDate(date.getDate() + 1)
        var month = ("00" + (date.getMonth() + 1)).slice(-2);
        var day = ("00" + date.getDate()).slice(-2);
        this.deadLineDay = date.getFullYear() + "-" + month + "-" + day

        this.dialog = true;
      },
      //日付範囲の終了日を返す
      getFutureDay() {
        let future = new Date();
        let tirdMonth = new Date(future.getFullYear(), future.getMonth() + this.$getMealCollectiveEndMonth() + 1, 0)
        future.setMonth(future.getMonth() + this.$getMealCollectiveEndMonth())
        let futureMonth = (future.getMonth() + 1).toString();
        if (futureMonth.length == 1) {
          futureMonth = "0" + futureMonth;
        }
        return future.getFullYear() + "-" + futureMonth + "-" + tirdMonth.getDate()// future.getDate();
      },
      //一括提供設定
      collectiveUpdate(offerFlg) {
        let params = {
          build_group_id: this.buildGroupId,
          start_date: this.collectiveStartDate,
          end_date: this.collectiveEndDate,
          dates: this.selectedDates,
          meals: this.selectedMeals,
          user_id: this.$store.getters.getUserId,
          offer_flg: offerFlg,
        }
        this.putRequest("/mealLunchSetting/mealOfferCollectiveUpdate", params, this.$store.getters.getUserToken).then((resp) => {
          if (resp.success) {
            this.close();
          } 
        });
      },
    }
  };
</script>

<style scoped>
  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }

  .MenuStyle {
    width: 100%;
    height: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
</style>